import React from "react";
import toast, { Toaster } from "react-hot-toast";
import './ToasterContainer.scss'

type ToastHtmlContentProps = {
  t: any
  message: string
  type: 'success' | 'error' | 'warning'
}

type ToasterMessage = {
  message: string
}

const toasterMapDefinitions = {
  'error': {
    'bootstrapClass': 'bg-danger',
    'icon': 'bi-x-circle-fill'
  },
  'warning': {
    'bootstrapClass': 'bg-warning',
    'icon': 'bi-exclamation-triangle-fill'
  },
  'success': {
    'bootstrapClass': 'bg-success',
    'icon': 'bi-check-circle-fill'
  }
}

const toastHtmlContent = ({ t, message, type }: ToastHtmlContentProps): React.JSX.Element => {
  return (
    <span>
      <div className={`toast fade align-items-center text-white ${toasterMapDefinitions[type]['bootstrapClass']} ${type} show`} data-bs-animation="true" data-bs-autohide="true" role="alert" aria-live="assertive" aria-atomic="true">
        <div className="d-flex">
          <div className="toast-body">
            <i className={`bi ${toasterMapDefinitions[type]['icon']} me-2 text-black`}></i>{message}
          </div>
          <button name="button" type="button" className="btn-close me-2 m-auto btn-close-white" data-bs-dismiss="toast" aria-label="Close" onClick={() => toast.dismiss(t.id)}></button>
        </div>
      </div>
    </span>
  )
}

const successToast = ({ message }: ToasterMessage) => {
  const toastContent = (t: any) => toastHtmlContent({ t, message, type: 'success' })

  toast.success(toastContent);
}

const warningToast = ({ message }: ToasterMessage) => {
  const toastContent = (t: any) => toastHtmlContent({ t, message, type: 'warning' })

  toast(toastContent);
}

const errorToast = ({ message }: ToasterMessage) => {
  const toastContent = (t: any) => toastHtmlContent({ t, message, type: 'error' })

  toast.error(toastContent);
}

const ToasterContainer = (): React.JSX.Element => {
  return (
    <div id="toaster-container">
      <Toaster containerClassName="toaster-element" position="bottom-right" reverseOrder={false}
        toastOptions={{
          duration: 8000,
          className: 'toaster-custom',
          icon: null,
          error: {
            duration: 0,
          }
        }}
      />
    </div>
  )
}

export { successToast, errorToast, warningToast }

export default ToasterContainer;
